import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/app/environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VendorService {
  private readonly apiUrl = environment.apiUrl;
  private readonly baseUrl = "vendor";
  private readonly baseUrlAdminVendor = "admin-vendor";

  constructor(private readonly http: HttpClient) {}

  private getUrl(route: string): string {
    return `${this.apiUrl}/${this.baseUrl}${route ? "/" + route : ""}`;
  }

  private getUrlAdminVendor(route: string = ""): string {
    return `${this.apiUrl}/${this.baseUrlAdminVendor}${
      route ? "/" + route : ""
    }`;
  }

  removeMobileNumberMaskSymbole(phoneNumber: string): string {
    if (typeof phoneNumber === "string") {
      return phoneNumber.replace(/\D/g, "");
    }
    return phoneNumber || null;
  }

  getVendorList(params: any): Observable<any> {
    return this.http.get<any>(this.getUrl(""), { params });
  }

  /**
   * @param skipGlobalLoader When true, adds `Skip-Loading` so {@link LoadingInterceptor}
   * does not show the full-page overlay (use local/table loading instead).
   */
  getParticipantsVendorList(
    params: any,
    skipGlobalLoader: boolean = false,
  ): Observable<any> {
    const options: { params: any; headers?: HttpHeaders } = { params };
    if (skipGlobalLoader) {
      options.headers = new HttpHeaders().set("Skip-Loading", "true");
    }
    return this.http.get<any>(this.getUrlAdminVendor(), options);
  }
  getSingleVendor(id: number): Observable<any> {
    return this.http.get<any>(this.getUrl(`${id}`));
  }

  inviteVendor(payload: any): Observable<any> {
    return this.http.post<any>(this.getUrl(""), payload);
  }

  fetchCategories(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/category/category-dropdown`);
  }

  fetchSubCategories(params: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/category/sub-category-dropdown`, {
      params,
    });
  }

  updateVendor(id: number, payload: any): Observable<any> {
    return this.http.patch<any>(this.getUrl(`${id}`), payload);
  }

  updateVendorStatus(id: number, payload: any): Observable<any> {
    return this.http.patch<any>(this.getUrl(`toggle/status/${id}`), payload);
  }

  createContactPerson(payload: any): Observable<any> {
    return this.http.post<any>(this.getUrl("contact/person"), payload);
  }

  deleteContactPerson(id: number): Observable<any> {
    return this.http.delete<any>(this.getUrl(`contact/person/${id}`));
  }

  fetchContactPersons(id: number): Observable<any> {
    return this.http.get<any>(this.getUrl(`contact/persons/${id}`));
  }

  fetchUserRoles(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/role/dropdown`);
  }

  fetchVendorKycDetails(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/kyc/${id}`);
  }

  updateVendorKycStatus(id: number, payload: any): Observable<any> {
    return this.http.patch<any>(
      `${this.apiUrl}/kyc/approve-status/${id}`,
      payload,
    );
  }

  fetchCommentHistory(id: number): Observable<any> {
    return this.http.get<any>(this.getUrl(`status/history/${id}`));
  }

  uploadProfile(id: number, payload?: any): Observable<any> {
    return this.http.patch<any>(
      this.getUrl(`update-profile-image/${id}`),
      payload,
    );
  }

  deleteProfileImage(id: number): Observable<any> {
    return this.http.delete<any>(this.getUrl(`delete-profile-image/${id}`));
  }

  inviteVendorAgain(id: number): Observable<any> {
    return this.http.get<any>(this.getUrl(`invite-vendor-again/${id}`));
  }

  getVendorDropDown(): Observable<any> {
    return this.http.get<any>(this.getUrl("dropdown"));
  }

  vendorTranscations(params: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/event`, { params });
  }

  getVendorProductList(uuid: string, params: any): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/fast-catalogue/manage-vendor-details/${uuid}`,
      { params },
    );
  }
}
